import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: "/", label: "Accueil" },
    { href: "/coaches", label: "Nos Coachs" },
    { href: "/apply", label: "Rejoindre" },
    { href: "/coach/login", label: "Espace Coach" },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    <>
      <header 
        className="fixed top-0 left-0 right-0 z-50 bg-[#05050A]/80 backdrop-blur-xl border-b border-white/10"
        data-testid="main-header"
      >
        <div className="container-custom">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <Link 
              to="/" 
              className="flex items-center gap-2"
              data-testid="logo-link"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_coach-hub-96/artifacts/uwrqhh9u_1777073959823.png" 
                alt="APM Logo"
                className="h-12 w-auto invert"
              />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-6" data-testid="desktop-nav">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`font-semibold text-sm uppercase tracking-wider transition-colors ${
                    isActive(link.href)
                      ? "text-[#0066FF]"
                      : "text-white/70 hover:text-white"
                  }`}
                  data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden lg:block">
              <Link
                to="/apply"
                className="bg-[#0066FF] hover:bg-[#3B82F6] text-white font-bold px-6 py-3 text-sm uppercase tracking-wider transition-all hover:-translate-y-0.5"
                data-testid="cta-apply-button"
              >
                Postuler
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-button"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="mobile-menu lg:hidden"
            data-testid="mobile-menu"
          >
            <button
              className="absolute top-6 right-6 text-white p-2"
              onClick={() => setMobileMenuOpen(false)}
              data-testid="mobile-menu-close"
            >
              <X className="w-8 h-8" />
            </button>
            
            {navLinks.map((link, index) => (
              <motion.div
                key={link.href}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={link.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={isActive(link.href) ? "text-[#0066FF]" : ""}
                  data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                >
                  {link.label}
                </Link>
              </motion.div>
            ))}
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
            >
              <Link
                to="/apply"
                onClick={() => setMobileMenuOpen(false)}
                className="bg-[#0066FF] px-8 py-4 mt-4"
                data-testid="mobile-cta-apply"
              >
                Postuler
              </Link>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
